{% block sw_extension_store_listing_filter %}
    <div class="sw-extension-store-listing-filter">
        <template v-if="!isLoading">
            {% block sw_extension_store_listing_filter_content %}
                {% block sw_extension_store_listing_filter_sorting %}
                    <sw-meteor-single-select
                        class="sw-extension-store-listing-filter__sorting"
                        size="small"
                        :label="$t('sw-extension.store.listing.sort')"
                        :options="sortingOptions"
                        value-property="orderIdentifier"
                        :value="sortingValue"
                        @update:value="setSelectedSorting"
                    />
                {% endblock %}

                {% block sw_extension_store_listing_all_filters %}
                    <sw-meteor-single-select
                        v-for="filter in listingFiltersSorted"
                        :key="filter.name"
                        class="sw-extension-store-listing-filter__filters"
                        size="small"
                        :label="filter.label"
                        :options="getOptionsForFilter(filter)"
                        :value="getValueForFilter(filter)"
                        @update:value="changeValueForFilter(filter, $event)"
                    >
                        <template
                            v-if="filter.type === 'category'"
                            #result-label-property="{ item, valueProperty }"
                        >
                            {% block sw_extension_store_listing_filter_category_filter_result %}
                                <div
                                    v-if="item[valueProperty] !== null"
                                    :class="{ 'is--root-category': isRootCategory(item) }"
                                    :style="{ 'padding-left': isRootCategory(item) ? '0': `${categoryDepth(item)}em` }"
                                >
                                    {{ item.label }}
                                </div>
                            {% endblock %}
                        </template>
                    </sw-meteor-single-select>
                {% endblock %}
            {% endblock %}
        </template>
        <template v-else>
            <sw-loader />
        </template>
    </div>
{% endblock %}
